import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../../../../../components/ButtonRounded";
import EditableTableContainer from "../../../../../../containers/sustainability/allocation/offRoad/EditableTable";
import {Typography} from "@material-ui/core";
import { ReactReduxContext, useDispatch } from "react-redux";
import {
    postSetActiveStepOffroad,
    postStepBiotemplatesData,
    putStepOverViewData
} from "../../../../../../api/sustainability/allocation/offRoadUse/stepData";
import MatchingTables from "../../../../../../containers/sustainability/allocation/offRoad/MatchingTables";
import setAllocationConstruction from "../../../../../../api/sustainability/allocationSteps/setAllocationConstruction";
import setAllocateConstructionReports from "../../../../../../api/sustainability/allocationSteps/setAllocateConstructionReports";
import OffRoadCustomerRequirements from "./OffRoadCustomerRequirements";
import SuccessView from "./SuccessView";
import {
    updateBiotemplateStepFour, updateBiotemplateStepOne, updateBiotemplateStepSurplusVol,
    updateBiotemplateStepThree, updateBiotemplateStepJointFulf, updateBiotemplateStepTwo
} from "../../../../../../reducers/sustainability/allocation/offRoadAllocation";
import parseToFloat from "../../../../../../components/texts/parseToFloat";
import { useMainCardStyles } from "../../../../../../common/styles/cardStyles";

const useStyles = useMainCardStyles;

interface OffRoadCardEditableTableProps {
    step: number;
    reqByCustomerDisabled: boolean;
    outJointDisabled: boolean;
    aboveMandateAfterFulfillDisabled: boolean;
    surplusStepDisabled: boolean;
    notApplicableStepDisabled: boolean;
    handleNext: () => void;
    handleBack: () => void;
    updateIsFetching: (value: boolean) => void;
    offroadGeneralPercentage: number;
    generalBiotemplates: any[];
    reservedBiotemplates: any[];
    jointBiotemplates: any[];
    additionalBiotemplates: any[];
    notApplicableBiotemplates: any[];
    generalAllocationNotNeeded: boolean;
    surplusBiotemplates: any[];
}
interface Biotemplate {
    id: number;
    biofuel_type: string;
    raw_material_origin: string;
    fuel_type: string;
    raw_material: string;
    double_counted_norway: string;
    reduction_in_climate_emission: number;
    storage_terminal: string;
    available_quantity: number;
    allocated_quantity: number;
    allocated_eq_quantity: number;
}
interface UpdatedDataProps {
    biotemplates?: any[];
    overview?: any[];
    id?: number;
}
interface Requirement {
    construction_volume_requirement: any;
    construction_reserved_req: any;
    joint_fulfillment_out: any;
    construction_additional_req: any;
    construction_na_req: any;
}
const OffRoadCardEditableTable: React.FC<OffRoadCardEditableTableProps> = ({
                                                                               step,
                                                                               reqByCustomerDisabled,
                                                                               outJointDisabled,
                                                                               aboveMandateAfterFulfillDisabled,
                                                                               surplusStepDisabled,
                                                                               notApplicableStepDisabled,
                                                                               handleBack,
                                                                               handleNext,
                                                                               updateIsFetching,
                                                                               offroadGeneralPercentage,
                                                                               generalBiotemplates,
                                                                               reservedBiotemplates,
                                                                               jointBiotemplates,
                                                                               additionalBiotemplates,
                                                                               notApplicableBiotemplates,
                                                                               generalAllocationNotNeeded,
                                                                               surplusBiotemplates
                                                                           }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isOverAllocated, setIsOverAllocated] = useState(false);
    const [updatedCustomerData, setUpdatedCustomerData] = useState([]);
    const [updatedData, setUpdatedData] = useState<any[]>([]);
    const [stepBiotemplates, setStepBiotemplates] = useState([]);
    const [requirementData, setRequirementData] = useState<Requirement>({
        construction_volume_requirement: {},
        construction_reserved_req: {},
        joint_fulfillment_out: {},
        construction_additional_req: {},
        construction_na_req: {},
    });

    const handleTableDataUpdate = (updatedData: UpdatedDataProps, type: string) => {
        if (type === "bio") {
            setUpdatedData(prevData => ({
                ...prevData,
                // @ts-ignore
                biotemplates: updatedData.biotemplates,
            }));
        } else {
            setUpdatedData(prevData => ({
                ...prevData,
                // @ts-ignore
                overview: updatedData.overview,
                id: updatedData.id,
            }));
        }

        if (step < 7 && updatedData.biotemplates) {
            setIsOverAllocated(updatedData.biotemplates.some(
                (item: { allocated_quantity: string; available_quantity: number }) =>
                    parseToFloat(item.allocated_quantity) > parseToFloat(item.available_quantity)
            ));
        }
    };

    const handleCustomerDataUpdate = (updatedCustomerData: any[]) => {
        // @ts-ignore
        setUpdatedCustomerData(updatedCustomerData);
    };

    const handleRequirementDataUpdate = (requirementData: Requirement) => {
        // @ts-ignore
        setRequirementData(requirementData);
    };

    const clickBack = () => {
        handleBack();
    };

    const clickNext = async () => {
        if (step < 7) {
            const biotemplateUpdatedData = {
                // @ts-ignore
                biotemplates : updatedData.biotemplates,
            };

            updateIsFetching(true);
            if (step == 0) {
            }
            if (step == 1) {
                dispatch(updateBiotemplateStepSurplusVol(biotemplateUpdatedData.biotemplates));
            }
            if (step == 2) {
                dispatch(updateBiotemplateStepOne(biotemplateUpdatedData.biotemplates));
            }
            if (step == 3) {
                dispatch(updateBiotemplateStepTwo(biotemplateUpdatedData.biotemplates));
            }
            if (step == 4) {
                dispatch(updateBiotemplateStepJointFulf(biotemplateUpdatedData.biotemplates));
            }
            if (step == 5) {
                dispatch(updateBiotemplateStepThree(biotemplateUpdatedData.biotemplates));
            }
            if (step == 6) {
                dispatch(updateBiotemplateStepFour(biotemplateUpdatedData.biotemplates));
            }

            const [setActiveStep, response] = await Promise.all([
                postSetActiveStepOffroad(step + 1),
                postStepBiotemplatesData(step, biotemplateUpdatedData)
            ]);

            if (response && response.success) {
                let shouldCallHandleNext = false;

                const apiCalls = [];
                if (step <= 6) {
                    // @ts-ignore
                    apiCalls.push(
                        setAllocationConstruction(
                            requirementData.construction_volume_requirement,
                            requirementData.construction_reserved_req,
                            requirementData.joint_fulfillment_out,
                            requirementData.construction_additional_req,
                            requirementData.construction_na_req,
                        )
                    );
                }
                if (step !== 6) {
                    // @ts-ignore
                    const overviewData = { ...updatedData.overview };
                    // @ts-ignore
                    overviewData.id = updatedData.id;
                    apiCalls.push(putStepOverViewData(step, overviewData));
                }

                if (apiCalls.length > 0) {
                    const results = await Promise.all(apiCalls);

                    if (step <= 6) {
                        const reqSetResponse = results[0];
                        if (reqSetResponse && reqSetResponse.valid) {
                            shouldCallHandleNext = true;
                        } else {
                            alert("Some error occurred");
                            updateIsFetching(false);
                            return;
                        }
                    }

                    if (step > 6) {
                        shouldCallHandleNext = true;
                    }
                }

                if (shouldCallHandleNext) {
                    handleNext();
                }
                updateIsFetching(false);
            } else {
                updateIsFetching(false);
                alert("Some error occurred");
            }
        } else {
            if (step > 6 && step < 10) {
                await postSetActiveStepOffroad(step + 1);
            }
            if (step === 8) {
                updateIsFetching(true);
                const getCustomerReqAllocated = () => {
                    // @ts-ignore
                    const allocated_sorted = updatedCustomerData.allocated_sorted;
                    let allocated: any = {};
                    if (allocated_sorted && Object.keys(allocated_sorted).length > 0) {
                        Object.keys(allocated_sorted).map((cust_id, cust_idx) => {
                            Object.keys(allocated_sorted[cust_id]).map((an_id, an_idx) => {
                                allocated = {
                                    ...allocated,
                                    [an_id]: {
                                        ...allocated_sorted[cust_id][an_id],
                                    },
                                };
                            });
                        });
                    }
                    return allocated;
                };
                const apiAllocated = getCustomerReqAllocated();

                try {
                    const response = await setAllocateConstructionReports(apiAllocated);
                    if (response.valid) {
                        updateIsFetching(false);
                        handleNext();
                    } else {
                        updateIsFetching(false);
                        alert("Some error occured when submitting data.");
                    }
                } catch (error) {
                    updateIsFetching(false);
                    alert("Some error occured when submitting data.");
                }
            } else {
                handleNext();
            }
        }
    };

    useEffect(() => {
        if (step === 1) {
            // @ts-ignore
            setStepBiotemplates(surplusBiotemplates);
        } else if (step === 2) {
            // @ts-ignore
            setStepBiotemplates(generalBiotemplates);
        } else if (step === 3) {
            // @ts-ignore
            setStepBiotemplates(reservedBiotemplates);
        } else if (step === 4) {
            // @ts-ignore
            setStepBiotemplates(jointBiotemplates);
        } else if (step === 5) {
            // @ts-ignore
            setStepBiotemplates(additionalBiotemplates);
        } else if (step === 6) {
            // @ts-ignore
            setStepBiotemplates(notApplicableBiotemplates);
        }
    }, [step, generalBiotemplates, reservedBiotemplates, jointBiotemplates, additionalBiotemplates, notApplicableBiotemplates]);
    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                <Grid
                    container
                    alignItems="flex-start"
                    justify="space-between"
                    wrap="nowrap"
                >
                    <Grid item xs>
                        {step === 1 && (
                            <>
                                <Typography variant="h4">Volume flexibility IN from road use mandate surplus</Typography>
                                <Typography variant="body2" >
                                    In this step you will specify the volume from the road use mandate surplus to be used as volume flexibility IN for the off-road mandate fulfillment. You cannot use more than the total road use mandate surplus. The allocation table below identifies the total available surplus of FAME and HVO/HRO from the road use mandate.
                                </Typography>
                                <br /><br />
                                {surplusStepDisabled && (
                                    <Typography variant="h5">
                                        This step is disabled.
                                    </Typography>
                                )}
                            </>
                        )}
                        {step === 2 && (
                            <>
                                <Typography variant="h4">Allocation of the off-road mandate ({offroadGeneralPercentage}%)</Typography>
                                <Typography variant="body2" >
                                    In this step you will allocate the sustainability criteria for the required volumes to fulfill the general off-road mandate. NB! The off-road mandate only accepts biofuels with advanced sustainablity criteria. If additional volumes are supplied to the market, this will be allocated in step 4 (all other volumes).
                                </Typography>
                                {generalAllocationNotNeeded && (
                                    <Typography variant="h5">
                                        Volume allocation is not needed due to mandate fulfilled with joint fulfillment IN
                                    </Typography>
                                )}
                                <br /><br />
                            </>
                        )}
                        {step === 3 && (
                            <>
                                <Typography variant="h4">Allocation of volumes required by customers to be above the mandate</Typography>
                                <Typography variant="body2" >
                                    In this step you will allocate the sustainability criteria for the volumes that customers have requested to be above the mandate levels. If there are additional volumes supplied to the market that is a surplus to the mandate levels, this will be allocated in step 4.
                                </Typography>
                                <br /><br />
                                {reqByCustomerDisabled && (
                                    <Typography variant="h5">
                                        This step is disabled as no volume has been registered in the volumes section
                                    </Typography>
                                )}
                            </>
                        )}
                        {step === 4 && (
                            <>
                                <Typography variant="h4"> Allocation of volumes subject to joint fulfillment OUT</Typography>
                                <Typography variant="body2">
                                    In this step you will allocate the sustainability criteria for the volumes that are subject to joint fulfillment OUT. This will be a part of the total volume above the mandate, including reserved volumes in step 2.
                                </Typography>
                                <br /><br />
                                {outJointDisabled && (
                                    <Typography variant="h5">
                                        This step is disabled as no joint fulfillment OUT volume has been registered in the volumes section
                                    </Typography>
                                )}
                            </>
                        )}
                        {step === 5 && (
                            <>
                                <Typography variant="h4">Allocation of additional volumes above the mandate</Typography>
                                <Typography variant="body2" >
                                    In this step you will allocate the sustainability criteria for all additional volumes above the mandate levels.
                                </Typography>
                                <br /><br />
                                {aboveMandateAfterFulfillDisabled && (
                                    <Typography variant="h5">
                                        This step is disabled as there are no additional volumes above the mandate to allocate
                                    </Typography>
                                )}
                            </>
                        )}
                        {step === 6 && (
                            <>
                                <Typography variant="h4">Allocation of volumes not applicable to the mandate</Typography>
                                <Typography variant="body2" >
                                    In this step you will allocate the sustainability criteria for potential sold bio volumes that are not applicable to the mandate. This will in practice be all dyed biofuel volumes with raw materials not qualifying to be advanced.
                                </Typography>
                                <br /><br />
                                {notApplicableStepDisabled && (
                                    <Typography variant="h5">
                                        This step is disabled as no non-advanced biofuel volume has been registered in the volumes section
                                    </Typography>
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid item style={{ flexShrink: 0 }}>
                        {step > 1 && (
                            <ButtonRounded
                                variant="outlined"
                                color="default"
                                className={classes.btn}
                                onClick={clickBack}
                            >
                                Back
                            </ButtonRounded>
                        )}
                        <ButtonRounded
                            variant="contained"
                            color="primary"
                            className={classes.btn}
                            onClick={clickNext}
                            disabled={step === 9 || isOverAllocated}
                        >
                            Next
                        </ButtonRounded>
                    </Grid>
                </Grid>
                {step === 7 && (
                    <MatchingTables/>
                )}
                {step === 8 && (
                    <OffRoadCustomerRequirements
                        onUpdateCustomerData={handleCustomerDataUpdate}
                    />
                )}
                {step === 9 && (
                    <SuccessView text={"Allocation process is successful"} />
                )}
                {step !== 7 && step !== 8 && step !== 9 && (
                    <EditableTableContainer data={stepBiotemplates}
                                            generalAllocationNotNeeded={generalAllocationNotNeeded}
                                            reqByCustomerDisabled={reqByCustomerDisabled}
                                            outJointDisabled={outJointDisabled}
                                            surplusStepDisabled={surplusStepDisabled}
                                            aboveMandateAfterFulfillDisabled={aboveMandateAfterFulfillDisabled}
                                            notApplicableStepDisabled={notApplicableStepDisabled}
                                            updateIsFetching={updateIsFetching}
                                            onUpdateData={handleTableDataUpdate}
                                            onUpdateRequirement={handleRequirementDataUpdate}
                                            activeStep={step} />
                )}
            </CardContent>
        </Card>
    );
};

export default OffRoadCardEditableTable;
